<template>
    <div class="border-radius-default item bg-gray-100 pl-0" role="button" @click="() => $emit('open', {...item})">
        <div class="d-flex">
            <div
                class="d-flex text-center flex-column align-content-center px-2 justify-content-center "
                :class="[statusBgColor, statusColor]"
                style="border-radius: 7px 0 0 7px">
                <i class="fi fi-rr-document px-2"></i>
            </div>
            <div class="d-lg-flex justify-content-between py-1 px-2 w-100 d-none align-items-center">
                <div class="col col-lg-4">
                    <h6 class="mb-0"> {{ title }}</h6>
                </div>
                <div class="col">
                    <span :class="[statusBgColor, statusColor]" class="badge fs-14 fw-bold">{{ status }}</span>
                </div>
                <div class="col">
                    {{ item.created_at|moment('DD-MM-YYYY') }}
                </div>
                <div class="col align-self-stretch text-end align-items-center d-flex justify-content-end">
                    <basic-button
                        id="classes" cls="btn-sm fw-bold me-2" icon="fi fi-rr-eye"
                        :text="trans('general.defaults.view')">
                    </basic-button>
                </div>
            </div>
            <div class="d-lg-none py-1 px-2 w-100 d-flex justify-content-between">
                <div>
                    <h6 class="fs-16 fw-bold" :class="statusColor">{{ title }}</h6>
                    <span :class="[statusBgColor, statusColor]" class="badge fs-14 fw-bold">{{ status }}</span>
                </div>
                <div class="text-end">
                    <div class="d-xl-flex justify-content-end mt-2">
                        <basic-button
                            id="classes" cls="btn-sm fw-bold me-2" icon="fi fi-rr-eye"
                            :text="trans('general.defaults.view')">
                        </basic-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import DropDownButton from "../../../theme/atoms/DropDownButton.vue";

export default {
    name: "SubmissionItem",
    components: {DropDownButton},
    props: {
        item: {
            type: Object,
            required: true
        },
        title: {
            type: String,
            required: false,
            default: function () {
                return (this.item.data?.name ?? '') + ' ' + (this.item.data?.surname ?? '')
            }
        }
    },
    computed: {
        status: function () {
            return trans(`general.page.space_forms.status.${this.item.status}`)
        },
        statusColor: function () {
            const statusColorMap = {
                'draft': 'text-dark',
                'submitted': 'text-blue',
                'approved': 'text-dark-green',
                'processing': 'text-warning',
                'rejected': 'text-danger',
            }
            return statusColorMap[this.item.status]
        },
        statusBgColor: function () {
            const statusColorMap = {
                'draft': 'bg-light',
                'submitted': 'bg-light-blue',
                'approved': 'bg-light-green',
                'processing': 'bg-light-warning',
                'rejected': 'bg-light-red',
            }
            return statusColorMap[this.item.status]
        },
    },
}
</script>
